import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { useSetRecoilState } from "recoil";
import { Box, InputLabel, MenuItem, SelectChangeEvent } from "@mui/material";
import {
  StyledFormControl,
  StyledSelect,
} from "./app-bar-contract-select.style";
import { useMyHrContractsByEmployee } from "my-hr/hooks";
import { MENU_IDS } from "oc/configs/menu-constants";
import { useOcCurrentUserState } from "oc/hooks";
import { ocActiveMenuState } from "oc/states/active-menu-state";

interface OcAppBarContractSelectProps {
  isMobile: boolean;
}

export const OcAppBarContractSelect = ({
  isMobile,
}: OcAppBarContractSelectProps) => {
  const { t } = useTranslation();
  const history = useHistory();

  let { employeeCode, setData: setCurrentUser } = useOcCurrentUserState();
  const {
    data: contractsData,
  }: {
    data:
    | Array<{
      code: string;
      jobClass?: { name: string };
      employmentType?: { code: string };
    }>
    | undefined;
  } = useMyHrContractsByEmployee({
    employee: employeeCode,
  });
  const setActiveMenu = useSetRecoilState(ocActiveMenuState);
  const { setData: setocCurrentUserState } = useOcCurrentUserState();
  const [contractCode, setContractCode] = useState("");

  useEffect(() => {
    if (contractsData && contractsData.length >= 1) {
      let sortedContracts = [...contractsData].sort((a, b) => {
        return (
          (Number(a?.employmentType?.code) || Infinity) -
          (Number(b?.employmentType?.code) || Infinity)
        );
      });
      let selectedId = sortedContracts[0].code;
      if (!contractCode) {
        setContractCode(selectedId);
        setCurrentUser({ contractCode: selectedId });
        setocCurrentUserState({ contractCode: selectedId });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contractsData]);

  const handleChange = (event: SelectChangeEvent<unknown>) => {
    setContractCode(event.target.value as string);
    setCurrentUser({ contractCode: event.target.value });
    setActiveMenu(MENU_IDS.MAIN);
    history.push("/");
  };

  if (!contractsData || contractsData.length === 0)
    return (
      <Box style={{ paddingRight: "16px", color: "#CC0033" }}>
        {t("MY_HR_CONTRACT_DATA_NOT_AVAIABLE")}
      </Box>
    );

  if (contractsData && contractsData?.length < 2) return <Box></Box>;

  return (
    <Box
      marginRight={isMobile ? "24px" : "16px"}
      marginLeft={isMobile ? "16px" : "0px"}
    >
      <StyledFormControl variant="outlined" size="small" isMobile={isMobile}>
        <InputLabel id="demo-simple-select-outlined-label">
          {t("MY_HR_GET_CONTRACT")}
        </InputLabel>
        <StyledSelect
          labelId="demo-simple-select-outlined-label"
          id="demo-simple-select-outlined"
          value={contractCode}
          onChange={handleChange}
          label={t("MY_HR_GET_CONTRACT")}
        >
          {contractsData?.map(
            (
              item: {
                code: string;
                jobClass?: { name: string };
                employmentType?: { code: string };
              },
              index: number,
            ) => {
              let label = item?.jobClass?.name;
              if (
                item?.employmentType?.code === "5" ||
                item?.employmentType?.code === "6"
              ) {
                label = t("MY_HR_CONTRACT_OF_SERVICES");
              }
              return (
                <MenuItem key={`${item?.code} ${index}`} value={item.code}>
                  {label}
                </MenuItem>
              );
            },
          )}
        </StyledSelect>
      </StyledFormControl>
    </Box>
  );
};

export default OcAppBarContractSelect;
